import { render, staticRenderFns } from "./DuplexCable.vue?vue&type=template&id=0c4ca20f"
import script from "./DuplexCable.vue?vue&type=script&lang=js"
export * from "./DuplexCable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports